import React from "react";

function AppointmentDetails() {
    return (
        <div style={{ margin: "0 auto", padding: "20px", }}>
            <h2 style={{ textAlign: "left", margin: "1rem 0" }}>Book Your Doctor's Appointment</h2>
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-start",
                    borderBottom: "2px solid #ddd",
                    paddingBottom: "1.5rem", // Adjusted padding bottom
                    marginBottom: "1rem",
                }}
            >
                <div>
                    <p style={{ margin: "0.5rem 0 0", color: "gray" }}>
                        <strong>Free</strong> • 15 - 30 minutes
                    </p>
                </div>
            </div>
        </div>

    );
}

export default AppointmentDetails;
